import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getParentEdgeTypeId } from '@iotv/datamodel';
import { BranchingQueryDefinition, NodeEdgeMapper, getItemTypeToGroupNestedDescendingQueryDef } from '@iotv/datamodel-core';
import { AdjacentType } from '@iotv/iotv-v3-types';
import { Stack, Typography } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { AppMainViewContext } from '../../../ContextProviders/AppContextProvider';
import { getGraphQueryRequestV2 } from '../../../data/daoFunctions/GraphQueries/recursiveFilteredGraphQuery';
const query = new BranchingQueryDefinition({
    path: [{ objectTypeId: 'Customer', adjacencyType: AdjacentType.PARENT, edgeTypeId: getParentEdgeTypeId('User', 'Customer') }],
    id: 'systemManagmentUserCustomersQuery_UserToCustomers',
    subQueries: [
        getItemTypeToGroupNestedDescendingQueryDef({
            groupDefiningObjectTypeId: 'Customer',
            supportedType: 'User',
            includeSupportedTypeInstances: true,
            addIdPrefixes: true,
        }),
        getItemTypeToGroupNestedDescendingQueryDef({
            groupDefiningObjectTypeId: 'Customer',
            supportedType: 'Device',
            includeSupportedTypeInstances: false,
            addIdPrefixes: true,
        }),
        // getItemTypeToGroupNestedDescendingQueryDef( { groupDefiningObjectTypeId: 'Customer', supportedType: 'Gateway', includeSupportedTypeInstances: false, addIdPrefixes: true }),
        // ...Object.keys(deviceEnabledTypes).map( ( type ) =>  getItemTypeToGroupNestedDescendingQueryDef( { groupDefiningObjectTypeId: 'Customer', supportedType: type, includeSupportedTypeInstances: false, addIdPrefixes: true }),)
    ],
});
export const RecursiveGraphQueryTemplate = ({}) => {
    const [{ contextUser: contextObject }] = useContext(AppMainViewContext);
    const getGraph = async (contextObjects, query) => {
        setErr(undefined);
        const res = await getGraphQueryRequestV2({ contextObjects, query });
        if (res.data) {
            setNodeEdgeMapper(new NodeEdgeMapper(res.data));
        }
        else {
            console.log('Err', res.err?.message);
            setErr(res.err?.message);
        }
    };
    const [nodeEdgeMapper, setNodeEdgeMapper] = useState(new NodeEdgeMapper());
    const [err, setErr] = useState(undefined);
    useEffect(() => {
        if (contextObject) {
            getGraph([contextObject], query);
        }
    }, [contextObject?.sk]);
    return (_jsxs(Stack, { children: [_jsxs("div", { children: [_jsx(Typography, { variant: 'h6', children: "Node Edge Mapper Summary" }), _jsxs("div", { children: [" ", JSON.stringify(nodeEdgeMapper.getSummary(), null, 1)] })] }), err && (_jsxs("div", { children: [_jsx(Typography, { variant: 'h6', children: "Errors" }), _jsxs("div", { children: [" ", err] })] }))] }));
};
